/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from "react";
import { intlShape, injectIntl } from "react-intl";
import { Col, Nav, NavItem, Row, Tab, Table } from "react-bootstrap";
import IntlMsg from "lorautils/intl/IntlMsg";
import HeatMapChart from "loracoms/HeatmapChart";
import SearchSelector from "loracoms/SearchSelector";
import SearchSelMultiple from "loracoms/SearchSelMultiple";
import Copy from "loracoms/Copy";
import callAPI from "@/api/callAPI";
import DeviceData from "@/containers/Application/coms/DeviceDetail/coms/DeviceData";
import Logs from "../TDMView/NodeStatus/Logs";
import { handleNodeData } from "./util";
import styles from "./styles.scss";

const propTypes = {
  intl: intlShape.isRequired,
};

class TDMStatis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      offsets: [],
      channels: [],
      nodeInfoMap: {},
      channelQuality: {},
      originChannels: [],
      sortKey: "asc",
      showKey: "better",
    };
    this.intlMsg = new IntlMsg(props.intl, "network");
    this.channelxOffData = {};
    this.nodesData = [];
    this.originOffsets = [];
    this.originChannels = [];
    this.filter = {};
    this.channelGtwName = {};
    this.servicesOpts = [
      { label: this.intlMsg.msg("tdmstatis.normal"), value: 1 },
      { label: this.intlMsg.msg("tdmstatis.gongtu"), value: 2 },
      {
        label: this.intlMsg.msg("tdmstatis.diancan"),
        value: 3,
      },
      { label: this.intlMsg.msg("tdmstatis.dianliutu"), value: 4 },
      { label: this.intlMsg.msg("tdmstatis.pressure"), value: 5 },
      { label: this.intlMsg.msg("tdmstatis.temperature"), value: 6 }, //压力与温度对调（数据原因修复bug）
    ];
    this.clickFn = this.clickFn.bind(this);
  }

  componentWillMount() {
    this.loadGatewayStatus();
  }

  loadGatewayStatus() {
    callAPI({
      endpoint: "/tdmng/gatewaystatus",
      method: "GET",
    })
      .then((res) => {
        const { List = [] } = res;
        List.forEach((l) => {
          const id = l.id;
          l.channels.forEach((c) => {
            const key = `${`00${c.channel}`.substr(-2)}_${id}`;
            this.channelxOffData[key] = c.sframe.xOffset;
            this.channelGtwName[key] = `${c.channel}_${l.name}`;
          });
        });
        this.loadData();
      })
      .catch();
  }

  loadData() {
    callAPI({
      endpoint: "/tdmng/nodestatus",
      method: "GET",
    })
      .then((res) => {
        const { List = [] } = res;
        // 获取可用的信息
        this.nodesData = _.map(List, (l) => {
          if (l.roaming && !_.isNil(l.binds) && l.binds.length > 0) {
            return l;
          }
          return null;
        });
        this.nodesData = _.filter(this.nodesData, (s) => s !== null);
        this.handleOriginData();
        this.handleData();
      })
      .catch(() => {});
  }

  handleOriginData() {
    const originData = handleNodeData(this.nodesData, this.channelxOffData);
    this.originOffsets = originData.offsets;
    this.originChannels = originData.channels;
    const originChannels = _.cloneDeep(this.originChannels);
    const channelQuality = originData.channelQuality;
    this.setState({ channelQuality, originChannels }, () => {
      const { sortKey, showKey } = this.state;
      this.handleSort(sortKey, showKey);
    });
    this.handleData();
  }

  handleData() {
    const result = handleNodeData(
      this.nodesData,
      this.channelxOffData,
      this.filter
    );
    const { offsets, channels } = result;
    let chartWidth = _.uniq(offsets);
    chartWidth = chartWidth.length * 15 + 160; // 因为left=150px, right=10px, 所以要加上160来计算总的宽度
    const chartHeight = channels.length * 25 + 80; // 因为bottom=80px, 所以要加上80来计算总的高度
    this.setState({ ...result, chartWidth, chartHeight });
  }

  handleChangeSelect(v, key) {
    this.setState({ [key]: v });
    this.filter[key] = v;
    this.handleData();
  }

  handleSort(sort, show) {
    const sortKey = _.xorBy(["asc", "desc"], [sort]);
    const { channelQuality } = this.state;
    let sortChannelQuality = _.sortBy(channelQuality, show);
    if (sortKey[0] === "desc") {
      sortChannelQuality = _.reverse(sortChannelQuality);
    }
    let newOriginChannels = [];
    sortChannelQuality.forEach((c) => {
      newOriginChannels = _.concat(newOriginChannels, [c.key]);
    });
    this.setState({
      sortKey: sortKey[0],
      showKey: show,
      originChannels: newOriginChannels,
    });
  }

  clickFn({ value } = {}) {
    if (!value) return;
    const index = `${value[0]}_${value[1]}`;
    const { nodeInfoMap } = this.state;
    const node = nodeInfoMap[index];
    if (!node) return;
    const { base: { id } = {} } = node;
    if (!id) return;
    this.setState({ deviceId: id, nodeStatus: { ...node, id } });
  }

  renderOffsetOpts() {
    const length = 500;
    // 获取一共有几组数据范围
    const endLength =
      _.ceil(this.originOffsets[this.originOffsets.length - 1] / length) || 0;
    // 获取选择的数据范围
    let offsetOpts = _.map(_.range(endLength), (f, index) => {
      const start = index * length;
      const end = (index + 1) * length;
      const obj = { label: `${start}-${end}`, value: `${start}-${end}` };
      return obj;
    });
    offsetOpts = _.concat(offsetOpts, [
      { label: `0-${endLength * length}`, value: `0-${endLength * length}` },
    ]);
    return offsetOpts;
  }

  renderChannelsOpts() {
    let channelsOpts = [];
    this.originChannels.forEach((c) => {
      channelsOpts = _.concat(channelsOpts, [
        { label: this.channelGtwName[c], value: c },
      ]);
    });
    return channelsOpts;
  }

  renderTable() {
    const { showKey, sortKey, originChannels, channelQuality } = this.state;
    return (
      <div style={{ padding: "15px" }}>
        <Table className={`aisz-table-light ${styles.statisTable}`}>
          <thead>
            <tr>
              <th>{this.intlMsg.msg("tdmstatis.gtwtitle")}</th>
              {/* <th>{this.intlMsg.msg('tdmstatis.sum')}</th> */}
              <th>{this.intlMsg.msg("tdmstatis.num")}</th>
              <th>{this.intlMsg.msg("tdmstatis.average")}</th>
              <th>
                {"<5"}
                <a
                  className={
                    showKey === "worst" ? styles.active : styles.noactive
                  }
                >
                  {showKey !== "worst" && (
                    <i
                      className="fa fa-sort-amount-asc"
                      onClick={() => this.handleSort("asc", "worst")}
                    />
                  )}
                  {showKey === "worst" && (
                    <i
                      className={`fa fa-sort-amount-${sortKey}`}
                      onClick={() => this.handleSort(sortKey, "worst")}
                    />
                  )}
                </a>
              </th>
              <th>
                {">=5"}
                <a
                  className={
                    showKey === "bad" ? styles.active : styles.noactive
                  }
                >
                  {showKey !== "bad" && (
                    <i
                      className="fa fa-sort-amount-asc"
                      onClick={() => this.handleSort("asc", "bad")}
                    />
                  )}
                  {showKey === "bad" && (
                    <i
                      className={`fa fa-sort-amount-${sortKey}`}
                      onClick={() => this.handleSort(sortKey, "bad")}
                    />
                  )}
                </a>
              </th>
              <th>
                {">=10"}
                <a
                  className={
                    showKey === "middle" ? styles.active : styles.noactive
                  }
                >
                  {showKey !== "middle" && (
                    <i
                      className="fa fa-sort-amount-asc"
                      onClick={() => this.handleSort("asc", "middle")}
                    />
                  )}
                  {showKey === "middle" && (
                    <i
                      className={`fa fa-sort-amount-${sortKey}`}
                      onClick={() => this.handleSort(sortKey, "middle")}
                    />
                  )}
                </a>
              </th>
              <th>
                {">=20"}
                <a
                  className={
                    showKey === "better" ? styles.active : styles.noactive
                  }
                >
                  {showKey !== "better" && (
                    <i
                      className="fa fa-sort-amount-asc"
                      onClick={() => this.handleSort("asc", "better")}
                    />
                  )}
                  {showKey === "better" && (
                    <i
                      className={`fa fa-sort-amount-${sortKey}`}
                      onClick={() => this.handleSort(sortKey, "better")}
                    />
                  )}
                </a>
              </th>
              <th>
                {">=40"}
                <a
                  className={
                    showKey === "good" ? styles.active : styles.noactive
                  }
                >
                  {showKey !== "good" && (
                    <i
                      className="fa fa-sort-amount-asc"
                      onClick={() => this.handleSort("asc", "good")}
                    />
                  )}
                  {showKey === "good" && (
                    <i
                      className={`fa fa-sort-amount-${sortKey}`}
                      onClick={() => this.handleSort(sortKey, "good")}
                    />
                  )}
                </a>
              </th>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(channelQuality) &&
              _.map(originChannels, (c, idx) => (
                <tr key={idx}>
                  <td>{this.channelGtwName[c]}</td>
                  <td>
                    <span>{channelQuality[c].num}</span>
                  </td>
                  <td>
                    <span>
                      {!_.isInteger(channelQuality[c].avg)
                        ? channelQuality[c].avg.toFixed(2)
                        : channelQuality[c].avg}
                    </span>
                  </td>
                  <td>
                    <span>{channelQuality[c].worst}</span>
                  </td>
                  <td>
                    <span>{channelQuality[c].bad}</span>
                  </td>
                  <td>
                    <span>{channelQuality[c].middle}</span>
                  </td>
                  <td>
                    <span>{channelQuality[c].better}</span>
                  </td>
                  <td>
                    <span>{channelQuality[c].good}</span>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );
  }

  render() {
    const {
      data,
      offsets,
      channels,
      deviceId,
      nodeInfoMap,
      chartWidth,
      chartHeight,
      copyText = "",
      nodeStatus = {},
    } = this.state;

    return (
      <section>
        <div className={styles.content}>
          <div>{this.intlMsg.msg("tdmstatis.title")}</div>
          <div className={styles.filter}>
            <div>
              <span>{this.intlMsg.msg("tdmstatis.offset")}</span>
              <SearchSelector
                onChange={(v) => this.handleChangeSelect(v, "offset")}
                options={this.renderOffsetOpts()}
              />
            </div>
            <div>
              <span>{this.intlMsg.msg("tdmstatis.gateway")}</span>
              <SearchSelMultiple
                onChange={(v) => this.handleChangeSelect(v, "channel")}
                options={this.renderChannelsOpts()}
              />
            </div>
            <div>
              <span>{this.intlMsg.msg("tdmstatis.service")}</span>
              <SearchSelMultiple
                onChange={(v) => this.handleChangeSelect(v, "service")}
                options={this.servicesOpts}
              />
            </div>
          </div>
          <div className={styles.chart}>
            <HeatMapChart
              series={[
                {
                  name: "TDM",
                  type: "heatmap",
                  data,
                  label: {
                    normal: {
                      show: false,
                    },
                  },
                },
              ]}
              visualMap={{
                min: 5,
                max: 40,
                minOpen: 5,
                maxOpen: 40,
                calculable: true,
                type: "piecewise",
                orient: "horizontal",
                left: "200px",
                top: "top",
              }}
              xAxis={{
                type: "category",
                data: offsets,
                splitArea: {
                  show: true,
                },
              }}
              yAxis={{
                type: "category",
                data: channels,
                splitArea: {
                  show: true,
                },
                offset: 2,
                axisLabel: {
                  formatter: (value) => this.channelGtwName[value],
                },
              }}
              animation={false}
              tooltip={{
                formatter: (params) => {
                  const nodeInfo =
                    nodeInfoMap[`${params.data[0]}_${params.data[1]}`];

                  return `${JSON.stringify(nodeInfo.base)}<br/>${JSON.stringify(
                    nodeInfo.counters
                  )}<br />${JSON.stringify(nodeInfo.time)}`;
                },
              }}
              grid={{
                left: "150px",
                right: "10px",
                bottom: "80px",
              }}
              width={`${chartWidth}px`}
              height={`${chartHeight}px`}
              clickFn={this.clickFn}
            />
          </div>
          <div>
            {this.intlMsg.msg("selectedpoint", "network")}
            {deviceId}&nbsp;
            {deviceId && <Copy id="copy" text={deviceId} />}
            {!deviceId && this.intlMsg.msg("nopoint", "network")}
          </div>
        </div>
        <Tab.Container
          id="tdm_container"
          defaultActiveKey="gateway"
          className={styles.tab}
        >
          <Row className="clearfix">
            <Col md={12}>
              <Nav bsStyle="aisz-tabs">
                <NavItem eventKey="gateway">
                  {this.intlMsg.msg(
                    "detailview.netstatus.title",
                    "gatewaydetail"
                  )}
                </NavItem>
                <NavItem eventKey="data">
                  {this.intlMsg.msg("data.header", "devicedetail")}
                </NavItem>
                <NavItem eventKey="logs">
                  {this.intlMsg.msg("tdm.node.channel.logs", "network")}
                </NavItem>
              </Nav>
              <Tab.Content animation className="aisz-tab-content-white">
                <Tab.Pane eventKey="gateway">{this.renderTable()}</Tab.Pane>
                <Tab.Pane eventKey="data">
                  {deviceId && <DeviceData deviceId={deviceId} />}
                  {!deviceId && (
                    <div className={styles.nodata}>
                      {this.intlMsg.msg("nopoint", "network")}
                    </div>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="logs">
                  {deviceId && <Logs nodeStatus={nodeStatus} />}
                  {!deviceId && (
                    <div className={styles.nodata}>
                      {this.intlMsg.msg("nopoint", "network")}
                    </div>
                  )}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
        <span
          id="tdmchart"
          style={{ display: "none" }}
          data-clipboard-text={copyText}
          ref={(ref) => {
            this.ref = ref;
          }}
        />
      </section>
    );
  }
}

TDMStatis.propTypes = propTypes;

export default injectIntl(TDMStatis);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMStatis/index.jsx